import React, { useEffect, useMemo } from "react";
import SelectFilter from "../SelectFilter";
import { getPropertyFIPS } from "app/NativeActions";
import { Wrapper, Row, Spin, Copy } from "app/NativeComponents/common";
import { useDispatch, useSelector } from "react-redux";

const PropertyCountyFilter = ({ filter_search, editLeadFilter }) => {
  const dispatch = useDispatch();
  const { token } = useSelector(state => state.auth);
  const { property_fips_loading, property_fips } = useSelector(
    state => state.filter
  );
  const { filter_property_state, filter_property_fips } = useSelector(
    state => state.filter.filters
  );
  const fipsOptions = useMemo(() => {
    if (!Array.isArray(property_fips)) return [];
    if (!filter_property_state) return [];
    return property_fips.filter(
      fips =>
        fips.state &&
        fips.state.toLowerCase() === filter_property_state.toLowerCase()
    );
  }, [property_fips, filter_property_state]);

  useEffect(() => {
    if (property_fips_loading || !token) return;
    dispatch(getPropertyFIPS({ token }));
  }, [token]);

  if (property_fips_loading)
    return (
      <Wrapper
        style={{
          padding: 20
        }}
      >
        <Row>
          <Spin size="small" />
          <Copy style={{ marginLeft: 10 }}>Loading counties...</Copy>
        </Row>
      </Wrapper>
    );

  if (fipsOptions.length > 0)
    return (
      <SelectFilter
        filter_title="Property Address County"
        filter_options={fipsOptions.map(f => ({
          label: f.county_name, // 'Hamilton County'
          value: f.code // 18057
        }))}
        filter_value={filter_property_fips}
        filter_prop={"filter_property_fips"}
        filter_search={filter_search}
        editLeadFilter={editLeadFilter}
      />
    );

  return <Wrapper />;
};
export default PropertyCountyFilter;
